<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("backupsettings", 1) }}</div>
      </div>
      <div>
        <b-button variant="default" to="add-backup-settings" class="btn-blue">{{
          $tc("add")
        }}</b-button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <!-- <div class="viewing-status">
          {{ $t('viewing')}}
          <span>1-20</span>of
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          v-if="GridViewFlag"
          class="btnj btn-listView"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(backup, backupkey) in backup_settings"
        :key="backupkey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ backup.cine_name }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item to="edit-backup-settings">
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item to="view-backup-settings">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>
            <div class="d-flex align-items-end">
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" />
                <span class="switch-slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="backup_settings.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-5">{{ $tc("status", 2) }}</span>
          </th>
          <th>{{ $tc("cinemaname", 1) }}</th>
          <th>{{ $tc("backuptype", 1) }}</th>
          <th>{{ $tc("backuptime", 1) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(backup, backupKey) in backup_settings" :key="backupKey">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                :checked="backup.bs_is_active == 'Y' ? true : false"
                type="checkbox"
                class="j-checkbox"
                disabled
              />
              <!-- <span class="switch-slider"></span>
                      </label> -->

              <!-- Edit Icon with Tooltip -->
              <span
                v-b-tooltip="'Edit'"
                tabindex="0"
                @click="
                  goToRoute(
                    '/master/edit-backup-settings',
                    backup,
                    backup.bs_id
                  )
                "
              >
                <span class="edit-pen blue-icon"></span>
              </span>

              <!-- View Icon with Tooltip -->
              <span
                v-b-tooltip="'View'"
                tabindex="0"
                @click="
                  goToRoute(
                    '/master/view-backup-settings',
                    backup,
                    backup.bs_id
                  )
                "
              >
                <span class="icon-eye mr-1 blue-icon"></span>
              </span>
            </div>
          </td>

          <td>{{ backup.cine_name }}</td>
          <td>{{ backup.bt_type }}</td>
          <td>{{ backup.bs_time1 }}</td>
          <!-- <td>
            <div class="d-flex align-items-center justify-content-end">
              <label class="ios-switch">
                <input
                  :checked="backup.bs_is_active == 'Y' ? true:false"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label>

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  @click="goToRoute('/master/edit-backup-settings',backup, backup.bs_id)"
                >
                  <span class="edit-pen"></span>
                  {{ $t('edit') }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/master/view-backup-settings',backup, backup.bs_id)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t('view') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
        </tr>
      </tbody>
      <tbody v-if="backup_settings.length == 0">
        <tr>
          <td colspan="2">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="backup_settings.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

 

<script>
import CinemasService from "@/services/CinemasService.js";
export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      backup_settings: [],
    };
  },
  mounted() {
    this.getAllBackupSettings();
  },
  beforeMount() {
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getAllBackupSettings();
      } else {
        this.currentPage = event;
        this.getAllBackupSettings();
      }
    },
    getAllBackupSettings: function () {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
      };
      CinemasService.GetAllBackupSetting(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.backup_settings = data.Records;
            // console.log("backup_settings :", this.backup_settings);
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          this.$toasted.show(err);
        });
    },
    /* eslint-disable */

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },

    goToRoute: function (path, { cine_id }, bs_id) {
      this.$router.push({
        path: path,
        query: {
          cinema_id: cine_id,
          backup_id: bs_id,
        },
      });
    },
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  },
};
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/BackupSettingComponent/backupSettings.vue